
import { updateAppConfig } from '#app'
import { defuFn } from '/home/firethewall/MSBNET/projeto_OO/OO-Administrador/node_modules/defu/dist/defu.mjs'

const inlineConfig = {
  "nuxt": {
    "buildId": "e7d8aa27-6d5d-46ed-849c-791971707bd3"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /* #__PURE__ */ defuFn(inlineConfig)
